import { applyMiddleware, createStore, Store } from "redux";
import * as ReduxThunk from "redux-thunk";
import { momentReviverUtc } from "tp/views/common/momentParsing";
import { Config } from "../shared/timeclock/models/index";

import { rootReducer } from "./reducers";

const persist = (reducersToSave) => (store) => (next) => (action) => {
    const ret = next(action);
    for (const reducerName of reducersToSave) {
        const str = JSON.stringify(store.getState()[reducerName]);
        window.localStorage.setItem(`reduxState-${reducerName}`, str);
    }

    return ret;
};

function read(reducerName: string, defaultValue: object) {
    const key = `reduxState-${reducerName}`;
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key), momentReviverUtc) : defaultValue;
}

export function createPersistedStore(configString: string): Store<{ config: Config }> {
    const config = JSON.parse(configString);

    const initialState = {
        config: { ...read("config", config), ...config },
        offline: read("offline", []),
        signatures: read("signatures", { items: [] })
    };

    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(ReduxThunk.default, persist(["config", "offline", "signatures"]))
    );
}
